import script from "./SessionStarted.vue?vue&type=script&setup=true&lang=js"
export * from "./SessionStarted.vue?vue&type=script&setup=true&lang=js"

import "./SessionStarted.vue?vue&type=style&index=0&id=7fb4ba63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb4ba63"]])

export default __exports__